<section class="aboutUs" id="aboutUsHome">
  <div class="container">
    <div class="row">
      <div class="col-lg-6">
        <h2 data-aos="fade-up">DISTRIBUIDOR CATERPILLAR EN 9 ESTADOS DE LA REPÚBLICA.</h2>
        <a routerLink="/sucursales" class="btnTracsa btnYellowWhite">CONOCER SUCURSALES</a>
      </div>
      <div class="col-lg-6" data-aos="fade-up">
        <p>
          Tenemos cobertura en Jalisco, Aguascalientes, Colima, Guanajuato, Michoacán, Nayarit, San
          Luis Potosí, Querétaro y Zacatecas.
        </p>
        <p>
          Nuestro portafolio está formado por la más amplia gama de soluciones para las industrias
          de la construcción, agricultura, minería y logística, así como para actividades en
          rellenos sanitarios, puertos marítimos y de transporte de materiales.
        </p>
        <p>
          Ofrecemos una extensa variedad de equipos nuevos y usados, disponibles para venta y renta,
          tanto de maquinaria pesada como ligera. Además, ponemos a tu disposición un catálogo
          completo de refacciones originales y un servicio técnico calificado. Nuestro objetivo es
          uno: hacer tu negocio más rentable.
        </p>
      </div>
      <div class="col-12 mapImage">
        <div id="spline-container"></div>
      </div>
    </div>
  </div>
</section>
